import { render, staticRenderFns } from "./choose-test-record.vue?vue&type=template&id=4b70d77c&scoped=true&"
import script from "./choose-test-record.vue?vue&type=script&lang=js&"
export * from "./choose-test-record.vue?vue&type=script&lang=js&"
import style0 from "./choose-test-record.vue?vue&type=style&index=0&id=4b70d77c&prod&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b70d77c",
  null
  
)

export default component.exports